'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import { HOW_IT_WORKS_ASSETS_PREFIX } from '../constants'

const HowItWorksHeader = () => {
  const translate = useTranslate('how_it_works.header')
  const asset = useAsset(HOW_IT_WORKS_ASSETS_PREFIX)

  const renderContent = () => (
    <div className="u-clearfix">
      <div className="grid6">
        <div className="row">
          <Text as="span" html>
            <div className="how-it-works__header-title">{translate('title')}</div>
          </Text>
          <Spacer size={Spacer.Size.XLarge} />
          <Text as="span" theme="muted">
            <div className="how-it-works__header-body">{translate('body')}</div>
          </Text>
        </div>
      </div>
    </div>
  )

  const renderImage = () => (
    <div className="how-it-works__header-image-container">
      <img src={asset('header.png')} alt="" />
    </div>
  )

  return (
    <>
      <div className="content-block how-it-works__header u-desktops-only">
        {renderImage()}
        <div className="container">
          <div className="content-block__content u-ui-margin-vertical-x5-large u-ui-margin-horizontal-large">
            {renderContent()}
          </div>
        </div>
      </div>

      <div className="u-mobiles-only">
        <div className="content-block how-it-works__header">
          <div className="container">
            <div className="content-block__content u-ui-margin-vertical-x6-large">
              {renderImage()}
            </div>
          </div>
        </div>
        <div className="tear tear--top u-background-greyscale-level-6 u-zindex-bump">
          <div className="container">
            <div className="content-block__content u-ui-margin-bottom-large u-ui-margin-horizontal-large">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HowItWorksHeader
